// Define icons that can be used for features
export const icons = [
  // Basic
  { id: 'star', name: 'Star' },
  { id: 'check', name: 'Check' },
  { id: 'heart', name: 'Heart' },
  { id: 'shield-check', name: 'Shield' },
  { id: 'home', name: 'Home' },
  { id: 'wrench', name: 'Tools' },
  { id: 'trophy', name: 'Award' },
  
  // Content
  { id: 'document-text', name: 'Document' },
  { id: 'document-check', name: 'Document Check' },
  { id: 'document-duplicate', name: 'Document Duplicate' },
  { id: 'clipboard-document', name: 'Clipboard' },
  { id: 'newspaper', name: 'Newspaper' },
  { id: 'book-open', name: 'Book Open' },
  { id: 'photo', name: 'Photo' },
  
  // Communication
  { id: 'chat-bubble-bottom-center-text', name: 'Chat' },
  { id: 'chat-bubble-left-right', name: 'Chat Bubbles' },
  { id: 'envelope', name: 'Envelope' },
  { id: 'phone', name: 'Phone' },
  { id: 'megaphone', name: 'Megaphone' },
  { id: 'bell', name: 'Bell' },
  { id: 'speaker-wave', name: 'Speaker' },
  
  // Time
  { id: 'clock', name: 'Clock' },
  { id: 'calendar', name: 'Calendar' },
  { id: 'calendar-days', name: 'Calendar Days' },
  { id: 'hourglass', name: 'Hourglass' },
  
  // People
  { id: 'user', name: 'User' },
  { id: 'user-group', name: 'Team' },
  { id: 'user-circle', name: 'User Circle' },
  { id: 'users', name: 'Users' },
  { id: 'identification', name: 'ID' },
  
  // Business
  { id: 'briefcase', name: 'Briefcase' },
  { id: 'currency-dollar', name: 'Money' },
  { id: 'credit-card', name: 'Credit Card' },
  { id: 'banknotes', name: 'Cash' },
  { id: 'chart-bar', name: 'Chart' },
  { id: 'presentation-chart-line', name: 'Chart Line' },
  { id: 'receipt-percent', name: 'Receipt' },
  { id: 'building-office', name: 'Building' },
  { id: 'building-storefront', name: 'Storefront' },
  
  // Transportation
  { id: 'truck', name: 'Truck' },
  { id: 'truck-container', name: 'Container Truck' },
  { id: 'car', name: 'Car' },
  { id: 'map', name: 'Map' },
  { id: 'map-pin', name: 'Location' },
  
  // Home & Construction
  { id: 'key', name: 'Key' },
  { id: 'home-modern', name: 'Modern Home' },
  { id: 'paint-brush', name: 'Paint' },
  { id: 'scissors', name: 'Scissors' },
  { id: 'squares-2x2', name: 'Grid' },
  { id: 'ruler', name: 'Ruler' },
  { id: 'wrench-screwdriver', name: 'Tools Set' },
  { id: 'beaker', name: 'Beaker' },
  
  // Nature & Environment
  { id: 'sparkles', name: 'Sparkles' },
  { id: 'fire', name: 'Fire' },
  { id: 'bolt', name: 'Lightning' },
  { id: 'sun', name: 'Sun' },
  { id: 'cloud', name: 'Cloud' },
  { id: 'hand-raised', name: 'Hand' },
  { id: 'globe-americas', name: 'Globe' },
  { id: 'globe-europe-africa', name: 'Globe Europe' },
  
  // Technology
  { id: 'computer-desktop', name: 'Desktop' },
  { id: 'device-phone-mobile', name: 'Mobile' },
  { id: 'cog', name: 'Settings' },
  { id: 'cog-6-tooth', name: 'Gear' },
  { id: 'command-line', name: 'Command' },
  { id: 'cpu-chip', name: 'Chip' },
  { id: 'wifi', name: 'WiFi' },
  { id: 'signal', name: 'Signal' },
  { id: 'lock-closed', name: 'Lock' },
  { id: 'server', name: 'Server' },
  
  // Action & Interface
  { id: 'arrow-right', name: 'Arrow' },
  { id: 'arrow-path', name: 'Refresh' },
  { id: 'arrow-trending-up', name: 'Trending Up' },
  { id: 'eye', name: 'Eye' },
  { id: 'hand-thumb-up', name: 'Thumbs Up' },
  { id: 'heart-filled', name: 'Heart Filled' },
  { id: 'link', name: 'Link' },
  { id: 'magnifying-glass', name: 'Search' },
  { id: 'paper-airplane', name: 'Send' },
  { id: 'rss', name: 'RSS' },
  { id: 'gift', name: 'Gift' },
  
  // Miscellaneous
  { id: 'academic-cap', name: 'Academic' },
  { id: 'adjustments-horizontal', name: 'Adjustments' },
  { id: 'archive-box', name: 'Archive' },
  { id: 'puzzle-piece', name: 'Puzzle' },
  { id: 'light-bulb', name: 'Lightbulb' },
  { id: 'tag', name: 'Tag' },
  { id: 'ticket', name: 'Ticket' },
  { id: 'shopping-bag', name: 'Shopping' },
  { id: 'shopping-cart', name: 'Cart' },
  { id: 'camera', name: 'Camera' },
];

/**
 * Get the full icon object by ID
 * @param iconId The ID of the icon
 * @returns The icon object, or a default if not found
 */
export function getIconById(iconId: string) {
  return icons.find(i => i.id === iconId) || icons[0];
} 